export const getEStoreProductList = state => {
    return state.list
}

export const getEStoreProductDataProps = state => {
    return state.props
}


// WEBPACK FOOTER //
// ./src/store/modules/eStoreProduct/getters.js